var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 0H9.41205C9.11001 0 8.86517 0.244836 8.86517 0.546875C8.86517 0.848914 9.11001 1.09375 9.41205 1.09375H12.1328L7.74905 5.47755C7.53547 5.69114 7.53547 6.03739 7.74905 6.25095C7.96261 6.4645 8.30886 6.46453 8.52244 6.25095L12.9062 1.86714V4.58793C12.9062 4.88997 13.1511 5.1348 13.4531 5.1348C13.7552 5.1348 14 4.88997 14 4.58793V0.546875C14 0.249238 13.7581 0 13.4531 0Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25095 7.74904C6.03736 7.53549 5.69111 7.53546 5.47755 7.74904L1.09375 12.1328V9.41206C1.09375 9.11002 0.848914 8.86519 0.546875 8.86519C0.244836 8.86519 0 9.11002 0 9.41206V13.4531C0 13.7502 0.242074 14 0.546875 14H4.58795C4.88999 14 5.13483 13.7552 5.13483 13.4531C5.13483 13.1511 4.88999 12.9062 4.58795 12.9062H1.86714L6.25095 8.52243C6.46453 8.30885 6.46453 7.9626 6.25095 7.74904Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.37fca10c44824ca6497fad070b2b98fb.svg";
export { ForwardRef as ReactComponent };